export enum MessageCategoryEnum {
  Question = 1,
  Suggestion,
  Help
};
